// src/hooks/pdf/usePurchasePreview.ts
import PurchasePdfService from '../../../services/purchases/pdf/PurchasePdfService';
import PurchaseTicketPdfService from '../../../services/purchases/pdf/TicketPdfService';
import { PreviewDocumentType } from '../../../types/pdf/PreviewDocumentType';

/**
 * Hook para obtener previsualizaciones de PDFs de compras
 * (ya sea documentos normales o tickets térmicos).
 */
export const usePurchasePreview = () => {
  /**
   * Obtiene un PDF y su nombre real desde el backend.
   *
   * @param purchaseId ID de la compra.
   * @param selectedType Tipo de documento a previsualizar ("PDF" o "TICKET").
   * @returns Objeto con el blob y el nombre del archivo, o null si falla.
   */
  const fetchPdfBlob = async (
    purchaseId: number,
    selectedType: PreviewDocumentType
  ): Promise<{ blob: Blob; fileName: string | null } | null> => {
    if (!purchaseId || !selectedType) return null;

    try {
      if (selectedType === 'TICKET') {
        const { blob, fileName } = await PurchaseTicketPdfService.view(purchaseId);
        return { blob, fileName };
      }

      const { blob, fileName } = await PurchasePdfService.view(purchaseId);
      return { blob, fileName };
    } catch (error) {
      console.error('❌ Error al obtener el PDF de compra:', error);
      return null;
    }
  };

  return { fetchPdfBlob };
};
